// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.TotalLabelContainer.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { get } from 'lodash/fp';
import FieldsContainer from './Izenda.LabelFieldContainer';
import DebouncedInput from 'share/components/controls/Izenda.DebouncedInput';

import { CONFIGURATION } from 'logic/data/Izenda.ReportPartChartConstants';

@observer
export default class TotalLabelContainer extends Component {
  render() {
    const props = this.props;
    const reportPart = props.reportPart;
    const label = props.label;
    const reportPartContent = reportPart.reportPartContent;

    return (
      <FieldsContainer label={label}>
        <DebouncedInput
          value={get('properties.optionByType.izTotalLabel', reportPartContent)}
          onChangeValue={this.onChangeData}
        />
      </FieldsContainer>
    );
  }

  onChangeData = value => {
    this.props.reportPart.reportPartContent.setTotalLabel(value);
  };
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/FieldContainers/Izenda.TotalLabelContainer.js